module.exports = __webpack_public_path__ + "b8e4baa30b7fd79ef3b158787d835586.pdf";